var React = require('react');
var ReactRouter = require('react-router');
var Link = ReactRouter.Link;

module.exports = React.createClass({
	
  getInitialState: function() {
    var secondSeg =  this.props.second ? this.props.second : [];

  	return { genderLink: "/collections/" + this.props.gender,
             genderText: "Womens" == this.props.gender || "womens" == this.props.gender ? "SHOP WOMEN'S" : "SHOP MEN'S",
             secondSeg: secondSeg,
             thirdSeg: [],
             gender: "" }
  },

  setSecondSeg: function(second) {
    var secondSeg;

    if (second.url) {
      secondSeg = <Link to={second.url}>{second.text}</Link>
    } else {
      secondSeg = <span>{second.text}</span>
    }
    this.setState({ secondSeg: secondSeg });
  },

  setThirdSeg: function(third) {
    this.setState({ thirdSeg: <span>&nbsp;&nbsp;&gt;&nbsp;&nbsp;{third}</span> });
  },

  setGender: function(gender) {
    this.setState({ genderText: "womens" == gender ? "SHOP WOMEN'S" : "SHOP MEN'S",
                    genderLink: "/collections/" + gender,
                    gender: gender })
  },

  render: function() {
    return <div className={"container breadcrumb " + this.props.className}>
        <Link to="/">HOME</Link>&nbsp;&nbsp;&gt;&nbsp;&nbsp;
        <Link to={ this.state.genderLink } >{ this.state.genderText }</Link>
        &nbsp;&nbsp;&gt;&nbsp;&nbsp;
        {this.state.secondSeg}
        {this.state.thirdSeg}
      </div>
  }
});